;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();import React from "react"
import Svg from "../images/profile.svg"
import { UI_STYLE_PRIMARY_BLUE_BLACK } from "../../../../../lib/constants"

export default function ProfileIcon() {
  return (
    <Svg
      viewBox="0 0 17 18"
      className="box-border inline-block h-[24px] w-[24px] shrink-0 rounded-[3px] border border-solid p-[2px] select-none"
      style={{ borderColor: UI_STYLE_PRIMARY_BLUE_BLACK }}
      aria-hidden="true"
      focusable="false"
    />
  )
}
